import { render, staticRenderFns } from "./MemberViewUserPermissionsCard.vue?vue&type=template&id=8f9f5f36&"
import script from "./MemberViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./MemberViewUserPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports